import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "table-title" }
const _hoisted_2 = { class: "table-title-text" }
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = { class: "table-container" }
const _hoisted_5 = ["innerHTML"]

import InnerContainer from "@/views/grammar/newGrammar/components/InnerContainer.vue";
import { ref, computed } from "vue";
import fillIcon from "@/assets/grammar/fill_icon.png";


export default /*@__PURE__*/_defineComponent({
  __name: 'Template3',
  props: {
  templateData: {
    type: Object,
    required: true,
  },
},
  setup(__props) {

const props = __props;

// 响应式状态，跟踪每个规则的显示/隐藏状态
const hiddenStates = ref<{ [key: number]: boolean }>({});

// 初始化隐藏状态
const initHiddenStates = () => {
  const count1List = props.templateData.content[0].count1List;
  count1List.forEach((_: any, index: number) => {
    hiddenStates.value[index] = true; // 默认显示
  });
};

// 在组件挂载时初始化状态
initHiddenStates();

// 切换显示/隐藏状态
const toggleVisibility = (ruleIndex: number) => {
  hiddenStates.value[ruleIndex] = !hiddenStates.value[ruleIndex];
};

// 处理语法说明中的特殊标签
const processSyntax = (syntax: string, ruleIndex: number) => {
  return syntax
    .replace(
      /<d>/g,
      `<span class="interactive-text underlined" data-rule-index="${ruleIndex}"><span class="text-content ${hiddenStates.value[ruleIndex] ? "hidden" : ""}">`
    )
    .replace(
      /<\/d>/g,
      `</span><span class="underline-placeholder"></span><img class="inline-toggle-icon" src="${fillIcon}" alt="" data-rule-index="${ruleIndex}" /></span>`
    )
    .replace(/<u>/g, "<u>")
    .replace(/<\/u>/g, "</u>")
    .replace(/<b>/g, "<strong>")
    .replace(/<\/b>/g, "</strong>")
    .replace(/<i>/g, "<em>")
    .replace(/<\/i>/g, "</em>")
    .replace(/<br\/>/g, "<br/>");
};

// 事件委托处理点击
const handleClick = (event: Event) => {
  const target = event.target as HTMLElement;
  if (target.classList.contains("inline-toggle-icon")) {
    const ruleIndex = target.getAttribute("data-rule-index");
    if (ruleIndex !== null) {
      toggleVisibility(parseInt(ruleIndex));
    }
  }
};

// 处理内容中的特殊标签
const processContent = (content: string) => {
  return content
    .replace(/<r>/g, '<span class="highlight-red">')
    .replace(/<\/r>/g, "</span>")
    .replace(/<l>/g, '<span class="highlight-blue">')
    .replace(/<\/l>/g, "</span>")
    .replace(/<y>/g, '<span class="highlight-yellow">')
    .replace(/<\/y>/g, "</span>")
    .replace(/<bl>/g, '<span class="highlight-blue">')
    .replace(/<\/bl>/g, "</span>")
    .replace(/<g>/g, '<span class="highlight-green">')
    .replace(/<\/g>/g, "</span>")
    .replace(/<u>/g, "<u>")
    .replace(/<\/u>/g, "</u>")
    .replace(/<b>/g, "<strong>")
    .replace(/<\/b>/g, "</strong>")
    .replace(/<i>/g, "<em>")
    .replace(/<\/i>/g, "</em>")
    .replace(/<br\/>/g, "<br/>");
};

// 获取所有词性
const getWordClasses = (count2List: any[]) => {
  return count2List.map((item) => item.wordClass);
};

// 获取最大行数
const getMaxRowCount = (count2List: any[]) => {
  return Math.max(...count2List.map((item) => item.count3List.length));
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(InnerContainer, {
    title: __props.templateData.pageTitle,
    "sub-title": __props.templateData.problem
  }, {
    default: _withCtx(() => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.templateData.content[0].count1List, (rule, ruleIndex) => {
        return (_openBlock(), _createElementBlock("div", {
          key: ruleIndex,
          class: "adverb-formation"
        }, [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", {
                class: "table-title-text-inner",
                onClick: handleClick,
                innerHTML: processSyntax(rule.syntax, ruleIndex)
              }, null, 8, _hoisted_3)
            ])
          ]),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("table", null, [
              _createElementVNode("thead", null, [
                _createElementVNode("tr", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getWordClasses(rule.count2List), (wordClass) => {
                    return (_openBlock(), _createElementBlock("th", { key: wordClass }, _toDisplayString(wordClass), 1))
                  }), 128))
                ])
              ]),
              _createElementVNode("tbody", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getMaxRowCount(rule.count2List), (rowIndex) => {
                  return (_openBlock(), _createElementBlock("tr", { key: rowIndex }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(rule.count2List, (wordClass) => {
                      return (_openBlock(), _createElementBlock("td", {
                        key: wordClass.wordClass
                      }, [
                        (wordClass.count3List[rowIndex - 1])
                          ? (_openBlock(), _createElementBlock("span", {
                              key: 0,
                              innerHTML: processContent(wordClass.count3List[rowIndex - 1].content)
                            }, null, 8, _hoisted_5))
                          : _createCommentVNode("", true)
                      ]))
                    }), 128))
                  ]))
                }), 128))
              ])
            ])
          ])
        ]))
      }), 128))
    ]),
    _: 1
  }, 8, ["title", "sub-title"]))
}
}

})